/**
 * Helpers for values produced by TranslatableInput.
 *
 * TranslatableInput emits either a plain string (single language) or a dict
 * shaped like { __base: "en", en: "…", ml: "…" }. Any UI that displays
 * these values must survive both shapes.
 */

/** Return the best plain string for display. Prefers the given locale, then base, then any non-empty entry. */
export function pickI18n(value, locale) {
  if (!value) return "";
  if (typeof value === "string") return value;
  if (typeof value !== "object") return String(value);
  if (locale && typeof value[locale] === "string" && value[locale].trim()) return value[locale];
  const base = value.__base;
  if (base && typeof value[base] === "string" && value[base].trim()) return value[base];
  for (const [k, v] of Object.entries(value)) {
    if (k === "__base") continue;
    if (typeof v === "string" && v.trim()) return v;
  }
  return "";
}
